import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { Skeleton } from '@/components/ui/FeedBack/Skeleton';
/**
 * スライド情報のSkeletonコンポーネント
 * @constructor
 */
export const PSearchSlideListItemSkeleton = (props) => {
    const { className = '' } = props;
    return (_jsxs("div", Object.assign({ className: clsx('group', 'flex flex-col', 'w-full', 'gap-y-12', className) }, { children: [_jsx("div", Object.assign({ className: clsx('rounded-md', 'bg-gray-75 border-2 border-solid border-gray-100', 'p-8 md:p-20') }, { children: _jsx(Skeleton, { className: clsx('w-full aspect-video') }) })), _jsx(Skeleton, { className: clsx('w-full h-[34px]') })] })));
};
